import { render, staticRenderFns } from "./KeyfeatureSlider.vue?vue&type=template&id=52034c2a&scoped=true&"
import script from "./KeyfeatureSlider.vue?vue&type=script&lang=js&"
export * from "./KeyfeatureSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52034c2a",
  null
  
)

export default component.exports